/* jshint loopfunc: true */
import * as Logger from 'loglevel'
import Utilities, { UtilConstant } from 'hub-utilities'
import * as APIContentFetcher from './APIContentFetcher'

export const SortOrder = Object.freeze({
  DEFAULT: 0,
  ASCENDING: 1, // Whole_col_right takes up the column in the right hand side, by 30%
  DESCENDING: 2 // Paragraph takes up the whole 2 bottom rows
})

var _keyToSort = ''
var _order = SortOrder.DEFAULT
var _arrOfTakenOutModifiedRows = []

// sortConfig: {key: null, order: SortOrder.DEFAULT}`
export const sort = (
  data,
  keyToSort,
  sortConfig,
  arrOfJustModifiedRows,
  arrOfModifiedRows
) => {
  // Key is sometimes null?  Perhaps the onClick event handler cannot return the key on-time with its async nature?
  // so have to check key isn't null here to solve the undefined key bug

  if (keyToSort) {
    _keyToSort = keyToSort
    _order = sortConfig.order

    var sortedData = []

    var dataToBeSorted = data.filter((item) => {
      return sortedData.indexOf(item) === -1
    })

    if (arrOfJustModifiedRows.length > 0 || arrOfModifiedRows.length > 0) {
      // Then, remove elemes that are in modifiedRows and create an array of {index: n, modifiedRowObj }
      // Data fetched is before sort, so to properly sort the previously sorted index of the edited row
      // Has to be fetched
      for (let i = 0; i < dataToBeSorted.length; i++) {
        var index1 = arrOfJustModifiedRows.findIndex(
          (elem) => !!elem.val && elem.val.id === dataToBeSorted[i].id
        )
        var index2 = arrOfModifiedRows.findIndex(
          (elem) => !!elem.val && elem.val.id === dataToBeSorted[i].id
        )
        if (index1 !== -1 || index2 !== -1) {
          if (index1 !== -1)
            _arrOfTakenOutModifiedRows.push({
              index: arrOfJustModifiedRows[index1].index,
              val: Object.assign({}, dataToBeSorted[i])
            })
          if (index2 !== -1)
            _arrOfTakenOutModifiedRows.push({
              index: arrOfModifiedRows[index2].index,
              val: Object.assign({}, dataToBeSorted[i])
            })
          dataToBeSorted[i] = null
        }
      }
    }

    dataToBeSorted = dataToBeSorted.filter((elem) => elem != null)
    dataToBeSorted.sort(compare)

    for (let i = 0; i < _arrOfTakenOutModifiedRows.length; i++) {
      dataToBeSorted.splice(
        _arrOfTakenOutModifiedRows[i].index,
        0,
        _arrOfTakenOutModifiedRows[i].val
      )
    }
    _arrOfTakenOutModifiedRows = []

    return sortedData.concat(dataToBeSorted)
  } else {
    return data
  }
}

const getCompareStr = (val) => {
  if (typeof val === 'string') {
    return val.toUpperCase()
  } else if (typeof val === 'object') {
    if (val.type === 'a') {
      return val.props.href ? val.props.href.toUpperCase() : ''
    }
  } else if (typeof val === 'number') {
    return val
  }
  Logger.error('Type of data is not supported by sort!')
  return ''
}

const compare = (a, b) => {
  // Compare the date here:
  const valA = a[_keyToSort].date
    ? getCompareStr(a[_keyToSort].date)
    : getCompareStr(a[_keyToSort].val)
  const valB = b[_keyToSort].date
    ? getCompareStr(b[_keyToSort].date)
    : getCompareStr(b[_keyToSort].val)

  let comparison = 0

  if (valA > valB) {
    comparison = 1
  } else if (valA < valB) {
    comparison = -1
  }

  // date is sorted in reverse order:
  if (
    (_order === SortOrder.DESCENDING && a[_keyToSort].date === undefined) ||
    (!!a[_keyToSort].date && _order === SortOrder.ASCENDING)
  ) {
    comparison *= -1
  }

  return comparison
}

function isHref(val) {
  return typeof val === 'object' && val.type === 'a'
}

// Filter:
export const filterSearch = (data, text) => {
  if (text !== '') {
    var newData = []
    for (var i = 0; i < data.length; i++) {
      Object.keys(data[i]).some((key, index) => {
        if (!!data[i][key] && !!data[i][key].val) {
          var val = data[i][key].val
          if (isHref(val)) val = val.props.children
          if (typeof val === 'number') val = val.toString()
          if (val.toLowerCase().includes(text.toLowerCase())) {
            newData.push(data[i])
            return true
          }
          return false
        }
        return false
      })
    }
    return newData
  } else return data
}

export const filterAvailableFilterObjs = (nodes, text, groups) => {
  if (text !== '') {
    var newNodes = []
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].name.toLowerCase().includes(text.toLowerCase())) {
        newNodes.push(nodes[i])
        continue
      }
      if (groups) {
        var matchedGrps = groups.filter((group) =>
          group.groupName.includes(text.toLowerCase())
        )
        if (nodes[i].groups) {
          nodes[i].groups.forEach((nodeGroupId) => {
            if (matchedGrps.some((group) => group.groupId === nodeGroupId)) {
              newNodes.push(nodes[i])
            }
          })
        }
      }
    }
    Logger.debug(newNodes)
    return newNodes
  } else return nodes
}

export const filterAvailableVocabs = (vocabs, text) => {
  if (text !== '') {
    var newVocabs = []
    for (var i = 0; i < vocabs.length; i++) {
      if (vocabs[i].toLowerCase().includes(text.toLowerCase())) {
        newVocabs.push(vocabs[i])
        continue
      }
    }
    Logger.debug(newVocabs)
    return newVocabs
  } else return vocabs
}

export const filteredFilterGroups = (
  filterGroups,
  filteredAvailableFilterObjs
) => {
  var filteredFilterGrps = []
  Logger.debug(filteredAvailableFilterObjs)
  filterGroups.forEach((filterGroup) => {
    if (
      filteredAvailableFilterObjs.some(
        (filteredAvailableFilterObj) =>
          !!filteredAvailableFilterObj.groups &&
          filteredAvailableFilterObj.groups.includes(filterGroup.groupId)
      )
    ) {
      filteredFilterGrps.push(filterGroup)
    }
  })
  return filteredFilterGrps
}

export const filterNewsObjMetadata = (newsObjMetadata, text) => {
  if (text !== '') {
    var newNewsObjMetadata = []
    for (var i = 0; i < newsObjMetadata.length; i++) {
      if (newsObjMetadata[i].toLowerCase().includes(text.toLowerCase())) {
        newNewsObjMetadata.push(newsObjMetadata[i])
        continue
      }
    }
    Logger.debug(newNewsObjMetadata)
    return newNewsObjMetadata
  } else return newsObjMetadata
}

export const updateDataPublishedTime = (data) => {
  var newData = data
  if (newData)
    newData.forEach((dataElem) => {
      Object.keys(dataElem).forEach((key, index) => {
        if (
          !!dataElem[key] &&
          !!dataElem[key].date &&
          !!dataElem[key].val &&
          !dataElem[key].isExactDate // if it's exact date, then no point of updating published time (it'll be the same nonetheless)
        ) {
          // format object date already helps to update such...
          dataElem[key].val = Utilities.formatObjectDate(
            dataElem[key].date,
            UtilConstant.HUB_TIME_FORMAT.CANADIAN,
            false,
            !!dataElem[key].isUtc
          )
          if (
            !!dataElem[key].icon &&
            Math.round(
              Math.round((new Date() - new Date(dataElem[key].date)) / 1000) /
                60
            ) > 9
          ) {
            // Remove "new" icon:
            dataElem[key].icon = undefined
          }
        }
      })
    })
  return newData
}
